export default {
      id: "ic-plan-ecoles-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-ecoles-usage",
      toString: function () {
        return this.url;
      }
    }